/* ============================================
   AURA FIT — theme.js
   Built in silence. Move with purpose.
   ============================================ */

// STICKY NAV — toggle .scrolled au scroll (utilise par layout/theme.liquid)
window.addEventListener('scroll', function(){
  var nav = document.getElementById('mainNav');
  if(nav) nav.classList.toggle('scrolled', window.scrollY > 60);
});

// REVEAL ON SCROLL — IntersectionObserver sur .reveal
(function(){
  var reveals = document.querySelectorAll('.reveal');
  if(!reveals.length) return;
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function(r){ obs.observe(r); });
})();

// QUICK ADD sur cartes produit — delegation d'evenement
// Cible : .af-card__quick[data-variant-id] genere par snippets/af-card.liquid
document.addEventListener('click', function(e){
  var btn = e.target.closest('.af-card__quick[data-variant-id]');
  if(!btn || btn.dataset.loading === 'true') return;
  e.preventDefault();
  var vid = btn.dataset.variantId;
  if(!vid) return;
  var label = btn.querySelector('.af-card__quick-label') || btn;
  var original = label.textContent;
  btn.dataset.loading = 'true';
  label.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ id: vid, quantity: 1 })
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    label.textContent = 'Ajouté';
    return fetch('/cart.js');
  })
  .then(function(r){ return r.json(); })
  .then(function(cart){
    document.querySelectorAll('.nav-cart-badge, .cart-count').forEach(function(b){
      b.textContent = cart.item_count;
    });
    var navCart = document.querySelector('.nav-cart');
    if(navCart && !navCart.querySelector('.nav-cart-badge') && cart.item_count > 0){
      var badge = document.createElement('span');
      badge.className = 'nav-cart-badge';
      badge.textContent = cart.item_count;
      navCart.appendChild(badge);
    }
    setTimeout(function(){
      label.textContent = original;
      btn.dataset.loading = '';
    }, 1800);
  })
  .catch(function(){
    label.textContent = 'Erreur';
    setTimeout(function(){
      label.textContent = original;
      btn.dataset.loading = '';
    }, 1500);
  });
});

// PAGE TRANSITIONS — fade in du main au chargement + fade out a la navigation
(function(){
  var mainEl = document.querySelector('main');
  if(!mainEl) return;
  mainEl.style.opacity = '0';
  mainEl.style.transform = 'translateY(18px)';
  mainEl.style.transition = 'none';
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      mainEl.style.transition = 'opacity 0.55s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.55s cubic-bezier(0.25,0.46,0.45,0.94)';
      mainEl.style.opacity = '1';
      mainEl.style.transform = 'translateY(0)';
    });
  });
  document.addEventListener('click', function(e){
    var link = e.target.closest('a');
    if(!link) return;
    var href = link.getAttribute('href');
    if(!href) return;
    if(href.startsWith('#')) return;
    if(href.startsWith('mailto:')) return;
    if(href.startsWith('tel:')) return;
    if(link.target === '_blank') return;
    if(href.startsWith('javascript')) return;
    if(e.ctrlKey || e.metaKey || e.shiftKey) return;
    e.preventDefault();
    mainEl.style.transition = 'opacity 0.35s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)';
    mainEl.style.opacity = '0';
    mainEl.style.transform = 'translateY(-10px)';
    setTimeout(function(){ window.location.href = href; }, 350);
  });
})();
